import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: { default: "#0B1120" },
    primary: { main: "#0284C7" },
    text: { primary: "#fff", secondary: "#94A3B8" },
  },
  shape: { borderRadius: 16 },
  typography: { fontFamily: "Inter, sans-serif" },
});

export default theme;
